import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["code", "status"]

  async copy(event) {
    event.preventDefault()

    const text = this.codeTargets
      .map((el) => el.textContent.trim())
      .filter(Boolean)
      .join("\n")
    if (!text) return

    try {
      await navigator.clipboard.writeText(text)
      this.announce("Copied Backup Codes to Clipboard")
    } catch {
      this.fallbackCopy(text)
    }
  }

  fallbackCopy(text) {
    const textarea = Object.assign(document.createElement("textarea"), { value: text })
    textarea.setAttribute("readonly", "")
    textarea.style.cssText = "position:fixed;left:-9999px"
    document.body.appendChild(textarea)
    textarea.select()

    try {
      this.announce(
        document.execCommand("copy")
          ? "Copied Backup Codes to Clipboard"
          : "Copy failed. Please copy the codes manually."
      )
    } catch {
      this.announce("Copy failed. Please copy the codes manually.")
    } finally {
      textarea.remove()
    }
  }

  announce(message) {
    if (!this.hasStatusTarget) return

    // Clear first so repeating the same message is re-announced.
    this.statusTarget.textContent = ""
    requestAnimationFrame(() => {
      this.statusTarget.textContent = message
    })
  }
}
